import { DialogContent } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import clsx from "clsx";
import _ from "lodash";
import MobileDetect from "mobile-detect";
import React, { useState } from "react";

const md = new MobileDetect(window.navigator.userAgent);

export const IframeDialog = (props) => {

    const { url = null, children, className } = props;
    const [openDialog, setOpenDialog] = useState(false);

    return (
        <React.Fragment>
            {!_.isNull(url) &&
                <div className={clsx(!_.isNull(className) ? className : "w-fit", "cursor-pointer")} onClick={() => setOpenDialog(true)}>
                    {children}
                </div>
            }
            {!_.isNull(url) &&
                <XAPPDialog
                    id="Iframe"
                    open={openDialog}
                    onClose={() => setOpenDialog(false)}
                    fullWidth
                    fullScreen={md.mobile() !== null}
                    maxWidth={md.mobile() === null && md.tablet() === null && "md"}
                >
                    <div className="flex w-full pl-24 bg-white">
                        <div style={{ flex: 1 }} />
                        <XAPPButton
                            className="p-8 "
                            icon="close"
                            type="icon"
                            iconProps="text-24 text-black"
                            onClick={() => setOpenDialog(false)}
                        />
                    </div>
                    <DialogContent className="bg-white p-0" style={{ height: "75vh" }}>
                        <iframe
                            id={`Iframe-${new Date().getTime()}`}
                            src={url}
                            width={"100%"}
                            height={"95%"}
                        ></iframe>
                    </DialogContent>
                </XAPPDialog>
            }
        </React.Fragment >
    );
};
